import { render, staticRenderFns } from "./SiadBatchProgress.vue?vue&type=template&id=44764d44&"
import script from "./SiadBatchProgress.vue?vue&type=script&lang=js&"
export * from "./SiadBatchProgress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports